import type { ReactNode } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import UpSwitchLanguageShop from '../../components/up-switch-language-shop';

import { invertTheme } from 'config/theme';
import { CustomerLoginWrapper, Main } from './styles';

import Header from './header';
import Footer from './footer';

interface CustomerLoginProps {
  children?: ReactNode;
}

const CustomerLogin = ({ children }: CustomerLoginProps) => (
  <ThemeProvider theme={invertTheme as DefaultTheme}>
    <CustomerLoginWrapper>
      <UpSwitchLanguageShop languageSwitch />
      <Main>
        <Header />
        {children}
      </Main>
      <Footer />
    </CustomerLoginWrapper>
  </ThemeProvider>
);

CustomerLogin.propTypes = {
  children: PropTypes.node,
};

export default CustomerLogin;
